export const getCompletionColor = (percentage: number): string => {
  if (percentage === 0) return 'var(--heat-0)';
  if (percentage <= 10) return 'var(--heat-10)';
  if (percentage <= 20) return 'var(--heat-20)';
  if (percentage <= 30) return 'var(--heat-30)';
  if (percentage <= 40) return 'var(--heat-40)';
  if (percentage <= 50) return 'var(--heat-50)';
  if (percentage <= 60) return 'var(--heat-60)';
  if (percentage <= 70) return 'var(--heat-70)';
  if (percentage <= 80) return 'var(--heat-80)';
  if (percentage <= 90) return 'var(--heat-90)';
  return 'var(--heat-100)';
};

export const getRatingColor = (rating: number): string => {
  if (rating >= 1 && rating <= 5) return `var(--rating-${rating})`;
  return 'var(--text-muted)';
};
